import { Box, CircularProgress } from '@mui/material';
import { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

function RequireAuth({ children }) {
    const { wait, user } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!wait && !user) {
            navigate('/login', { state: { from: location.pathname }, replace: true });
        }
    }, [wait, user, navigate, location.pathname]);

    if (wait) {
        return (
            <Box className="flex justify-center py-20">
                <CircularProgress size={70} />
            </Box>
        );
    }

    if (!user) return null;

    return children;
}

export default RequireAuth;
